import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, Form, TextAreaInput } from '../../../UI'

import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourInfo.graphql'
import { NotificationManager } from 'react-notifications';

class AddInfo extends Component {
  state = {
    saving: false
  }

  componentDidMount() {
    this.setState({
      securityNotice: this.props.currentSteps.securityNotice || '',
      weatherNotice: this.props.currentSteps.weatherNotice || ''
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, updateSteps, history } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        securityNotice: values.securityNotice,
        weatherNotice: values.weatherNotice
      }
    }).then(() => {
      this.setState(
        {
          saving: false
        },
        () => {
          updateSteps()
          NotificationManager.success('Additional info updated', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            history.push(`/activity-steps/${data.allLocalTours[0].id}/meeting-point`)
          } else {
            history.push('/activity-steps/meeting-point')
          }
        }
      )
    }).catch(err=>NotificationManager.error('Error while updating additional info', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('add_info')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <label className="steps-screen__form-input-label">{t('security_notice')}</label>
            <div className="form-input-example">{t('security_example')}</div>

            <TextAreaInput
              id="securityNotice"
              placeholder={''}
              initialValue={this.state.securityNotice}
              maxChars={200}
              labelClass="steps-screen__form-input-label"
            />

            <label style={{ marginTop: 25 }} className="steps-screen__form-input-label">
              {t('weather_notice')}
            </label>
            <div className="form-input-example">{t('weather_example')}</div>

            <TextAreaInput
              id="weatherNotice"
              placeholder={''}
              initialValue={this.state.weatherNotice}
              maxChars={200}
              labelClass="steps-screen__form-input-label"
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(AddInfo)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MoreDetails/AddInfo.jsx